<template>
  <div class="section_10 flex-row">
    <div class="text-group_14 flex-col justify-between">
      <span class="text_26">千万家居行业品牌店铺入驻</span>
      <span class="text_27">在线选购，足不出户逛家装</span>
    </div>
    <div class="shouji" style="position: fixed;top: 20%;left: 60%">
      <img src="../assets/shoujiduan.webp" alt="图片描述" style="width: 584px; height: 708px;"/>
    </div>
    <div class="box_2 flex-col"></div>
    <div class="" style="position: absolute;  left: 1214px;  top: 854px;  width: 151px;  height: 131px;color: white">扫码进入微信小程序</div>
  </div>
</template>

<script>

export default {
  name: 'TechnicalCommittee',
  data() {
    return {
      committeeMembers: [],
      startX: null,
      startY: null,
    };
  },
  methods: {
    // 新增触摸事件处理
    handleTouchStart(e) {
      this.startY = e.touches[0].clientY;
    },
    handleTouchEnd(e) {
      if (!this.startY) return;
      const endY = e.changedTouches[0].clientY;
      const deltaY = endY - this.startY;
      const deltaX = Math.abs(e.changedTouches[0].clientX - this.startX);
      console.log('1',deltaY,deltaX,Math.abs(deltaY))

      // 垂直滑动距离大于30px且水平滑动小于50px时才触发
      if (Math.abs(deltaY) > 50 && deltaX < 400) {
        if (deltaY > 0) { // 向下滑动
          this.$router.push('/building.html'); // 跳转

        } else if (deltaY < 0) { // 向上滑动
          this.$router.push('/member-list.html');
        }
      }
      this.startY = null;
    },
    handleWheelScroll(e) {
      if (e.ctrlKey || e.metaKey) return; // 过滤组合键操作

      if (e.deltaY > 0) { // 检测向下滚动
        this.$router.push('/member-list.html');
      }else if (e.deltaY < 0) { // 检测向上滚动
        this.$router.push('/building.html'); // 跳转
      }
    },
    handleKeyDown(e) {
      // 阻止Ctrl+加号/减号/鼠标滚轮
      if ((e.ctrlKey === true || e.metaKey) &&
          (e.keyCode === 61 || e.keyCode === 107 ||
              e.keyCode === 173 || e.keyCode === 109 ||
              e.keyCode === 187  || e.keyCode === 189)) {
        e.preventDefault();
      }
    },
    handleWheel(e) {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    },
    handleTouchMove(e) {
      if (e.scale !== 1) {
        e.preventDefault();
      }
    },
  },
  mounted() {
    // 添加触摸事件监听
    document.addEventListener('touchstart', this.handleTouchStart, { passive: false });
    document.addEventListener('touchend', this.handleTouchEnd, { passive: false });
    // 添加滚轮事件监听
    window.addEventListener('wheel', this.handleWheelScroll);
    // 禁用快捷键缩放
    document.addEventListener('keydown', this.handleKeyDown);
    // 禁用双指缩放（移动端）
    document.addEventListener('wheel', this.handleWheel, { passive: false });
    // 禁用触摸事件缩放
    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
  },
  beforeUnmount() {
    // 移除触摸事件监听
    document.removeEventListener('touchstart', this.handleTouchStart);
    document.removeEventListener('touchend', this.handleTouchEnd);
    // 移除滚轮事件监听
    window.removeEventListener('wheel', this.handleWheelScroll);
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('wheel', this.handleWheel);
    document.removeEventListener('touchmove', this.handleTouchMove);
  },
  computed: {
    containerStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: 'top left',
        width: `${100 / this.scale}%`,
        height: `${100 / this.scale}%`
      };
    }
  },
};
</script>

<style>
@media (max-width: 768px) {
  .section_10 {
    z-index: 0 !important;
  }
  .text-group_14 {
    margin: 126px 0 0 !important;
    align-items: flex-start; /* 移动端保持左对齐 */
    transform: translateX(-50%) scale(0.50) !important;  /* 水平居中 */
    left: 50% !important;  /* 新增定位 */
    position: relative;
  }
  .shouji{
    position: relative;
    top: 15% !important;
    left: 50%!important;
    transform: translateX(-50%) scale(0.58) !important;  /* 水平居中 */
  }
}
.box_2 {
  border-radius: 50%;
  background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/83da02e26c5d4dc99c2a909fe56aa8af_mergeImage.png);
  position: absolute;
  left: 1214px;
  top: 724px;
  width: 131px;
  height: 131px;
}


.section_10 {
  background-image: url(../assets/shoujiduanbeijing.webp);
  width: 100vw;
  height: 100vh;
  /* 绝对定位覆盖全屏 */
  position: fixed;
  top: 0;
  left: 0%;
  z-index: -1;
  /* 背景图等比例填充 */
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}

.text-group_14 {
  width: 577px;
  height: 112px;
  margin: 286px 0 0 253px;
}

.text_26 {
  width: 577px;
  height: 65px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 50px;
  letter-spacing: 1.5499999523162842px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 75px;
}

.text_27 {
  width: 393px;
  height: 36px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 28px;
  letter-spacing: 7.12999963760376px;
  font-family: PingFangSC-Light;
  font-weight: 300;
  text-align: left;
  white-space: nowrap;
  line-height: 36px;
  margin-top: 11px;
}
</style>